interface ICollectionPosterProps {
  title: string;
  posterUrl: string | null | undefined;
  titleInPoster?: number;
  challengeCount?: number;
  countLabel?: string;
  parentTitle?: string | null;
  badgeLabel?: string;
  footerLabel?: string;
}

export function CollectionPoster({
  title,
  posterUrl,
  titleInPoster,
  challengeCount,
  countLabel,
  parentTitle,
  badgeLabel,
  footerLabel,
}: ICollectionPosterProps): React.JSX.Element {
  const showTitle = titleInPoster !== 1;
  const showFooterOverlay = Boolean(posterUrl) && (showTitle || Boolean(footerLabel));
  return (
    <>
      {posterUrl ? (
        <img
          src={posterUrl}
          alt={title}
          loading="lazy"
          decoding="async"
          className="absolute inset-0 size-full object-cover transition group-hover:scale-105"
        />
      ) : (
        <div className="flex size-full flex-col items-center justify-center gap-1 p-3 text-center">
          {parentTitle && (
            <span className="text-xs text-muted-foreground line-clamp-1">{parentTitle}</span>
          )}
          <span className="text-sm font-semibold text-foreground line-clamp-2">{title}</span>
          {footerLabel && (
            <span className="mt-1 text-xs text-muted-foreground line-clamp-1">{footerLabel}</span>
          )}
        </div>
      )}
      {badgeLabel != null && (
        <span className="absolute right-1.5 top-1.5 rounded-lg bg-black/30 px-2 py-1 text-xs font-bold text-white backdrop-blur-md">
          {badgeLabel}
        </span>
      )}
      {challengeCount != null && (
        <span
          role="img"
          aria-label={countLabel}
          className="absolute right-1.5 top-1.5 rounded-lg bg-black/30 px-2 py-1 text-xs font-bold text-white backdrop-blur-md"
        >
          {challengeCount}
        </span>
      )}
      {showFooterOverlay && (
        <div className="absolute inset-x-0 bottom-0 bg-linear-to-t from-black/80 to-transparent p-2.5 pt-8">
          {showTitle && <h3 className="text-sm font-medium text-white line-clamp-1">{title}</h3>}
          {footerLabel && (
            <p className="mt-0.5 text-xs font-medium text-white/70 line-clamp-1">{footerLabel}</p>
          )}
        </div>
      )}
    </>
  );
}
